import React, { Fragment, useContext, useEffect, useState } from 'react';
import Product from '../sales/Product';
import Toast from '../helpers/Toast';
import Spinner from '../helpers/Spinner';
import { AuthContext } from '../../context/Auth.context';
import { useNavigate } from 'react-router-dom';
import { addCakeLabel, getProductLabels } from '../services/catalogServices';

const CakeLabelAdd = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [current_page, setCurrent_page] = useState(1);
    const { state, CheckResponse } = useContext(AuthContext);
    const [current_cake, setCurretCake] = useState([]);
    const [modal_add_cake_label_preview, setModalAddCakeLabelPreview] = useState(false);
    const [selectedCake, setSelectedCake] = useState(false);
    const [label_list, setLabelList] = useState({ labels: [], id_product: 0 });
    const [label_value, setLabelValue] = useState("");
    const [products, setProducts] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState('');

    const showToast = (t, d, tt) => {
        setList([...list, {
            id: Math.floor((Math.random() * 101) + 1),
            title: t,
            description: d,
            type: tt
        }]);
    }

    useEffect(() => {
        getProductsAvilable();
    }, [current_page]);

    const getProductsAvilable = () => {
        getProductLabels(state.auth, state.config.label_products.trim()).then(data => {
            CheckResponse(data);
            console.log(data, "sfh", state.config.label_products)
            if (data.code == 200) {
                setProducts(data.data);
                if (data.data.length > 0) {
                    setSelectedCategory(data.data[0].name);
                }
            } else {
                showToast('Oops!', 'Algo salio mal!', 'danger');
            }
        })
    }

    const addLabelCakeModal = (cake) => {
        setCurretCake(cake);
        setSelectedCake(true);
        setModalAddCakeLabelPreview(true);
    }

    const addLabelToList = () => {
        if (label_value) {
            console.log(label_list)
            const labelValuesArray = label_value.split(',').map(value => value.trim()).filter(value => value !== '');
            labelValuesArray.forEach(value => {
                if (label_list.labels.some(label => label.label_value === value)) {
                    showToast('Oops!', 'Etiqueta ' + value + ' duplicada!', 'danger');
                } else {
                    setLabelList(prevState => ({
                        labels: [...prevState.labels, { 'label_value': value }]
                    }));
                }
            });
            setLabelValue('')
        }
    }

    const closeAddCakeLabelModal = () => {
        setModalAddCakeLabelPreview(false);
        setLabelList([]);
        setLabelValue('');
    }

    const removeLabel = (labelToRemove) => {
        console.log(label_list)
        console.log(labelToRemove)
        setLabelList(prev => ({
            ...prev,
            labels: prev.labels.filter(label => label.label_value !== labelToRemove)
        })
        );
    }

    const addLabel = () => {
        console.log(current_cake)
        setLoading(true)
        const updatedList = {
            ...label_list,
            id_product: current_cake.id
        }
        let error = false;

        if (!error && updatedList.labels.length == 0) {
            error = true;
            showToast('Oops!', 'No se han agregado etiquetas!', 'warning');
            setLoading(false)
        }
        if (!error) {
            console.log("Payload final enviado:", JSON.stringify(updatedList, null, 2));

            addCakeLabel(state.auth, updatedList).then(data => {
                CheckResponse(data);
                if (data.code == 200) {
                    showToast('Hecho!', 'Guardado con exito, Redireccionando a otra pagina!', 'success');
                    setTimeout(function () {
                        navigate('/cake-labels');
                    }, 5000);
                } else {
                    showToast('Oops!', 'Algo salio mal!', 'danger');
                    setLoading(false)
                }
            });
        }
    }

    return (
        <>
            <Toast
                toastList={list}
            />
            <div className="row">
                <div className="col-sm-4">
                    <h1>Agregar Etiqueta</h1>
                </div>
            </div>
            {products.length > 0 && <div className="col-sm-8 mt-5 mx-5">
                <div className="row">
                    <div className="col-sm-12">
                        {products.map(category =>
                            <button key={category.name} className={`btn ${selectedCategory == category.name ? 'btn-light' : 'btn-primary'}  ms-1 mb-1`} type="button" onClick={() => { setSelectedCategory(category.name) }}>
                                {category.name}
                            </button>
                        )}
                    </div>
                </div>
                {products.map(category =>
                    <div key={category.name} className={`row mt-2 collapse ${selectedCategory == category.name ? 'show' : ''}`}>
                        <>
                            {category.products.length > 0 && category.products && category.products.map && category.products.map(product =>
                                <Product key={product.id} add={addLabelCakeModal} product={product}></Product>
                            )}
                            {category.products.length == 0 &&
                                <div className="col-sm-12 text-center">
                                    <h2 className=' mt-4'>No hay productos</h2>
                                </div>}
                        </>
                    </div>
                )}
            </div>}

            <div className="modal fade show" style={{ background: "rgba(0, 0, 0, 0.8)", display: modal_add_cake_label_preview ? 'block' : 'none' }}>
                <div className="modal-dialog">
                    {loading && <div className="col-sm-4 mt-1">
                        <Spinner size={3} margin={4}></Spinner>
                    </div>}
                    {!loading && <>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Etiquetas para: {selectedCake && current_cake.name}</h5>
                                <button onClick={() => { closeAddCakeLabelModal() }} type="button" className="btn-close"></button>
                            </div>
                            <div className="modal-body">

                                <div className="row mt-2">
                                    <div className="col-sm-8 mt-1">
                                        <label>Etiqueta</label>
                                        <input type="text" value={label_value} onChange={(e) => { setLabelValue(e.target.value) }} className='form-control'></input>
                                    </div>
                                    <div className="col-sm-4 mt-1">
                                        <button className="btn btn-primary mt-4" onClick={addLabelToList}>Agregar</button>
                                    </div>
                                </div>
                                <div className="row mt-4">
                                    <div className="col-12" id="cake-labels-list">
                                        {label_list.labels && label_list.labels.length > 0 ? (label_list.labels.map(cakeLabel => <button key={cakeLabel.label_value} type="button" className="btn btn-sm btn-secondary m-1">{cakeLabel.label_value}<span className="badge badge-light labelRemove" onClick={() => { removeLabel(cakeLabel.label_value) }}>X</span></button>)
                                        ) : (<></>)}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button onClick={() => { closeAddCakeLabelModal() }} className="btn btn-danger" type="button">Cancelar</button>
                                <button type="button" onClick={() => { addLabel() }} className="btn btn-success">Agregar Etiqueta</button>
                            </div>
                        </div>
                    </>}
                </div>
            </div>
        </>
    );
}

export default CakeLabelAdd;